import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  createFeedbackCollectionApiService,
  type CreateFeedbackCollectionRequest,
  type CreateFeedbackCollectionResult,
} from "@/generated/fastapi";

export async function createFeedbackLink(
  accessToken: string | null | undefined,
  request: CreateFeedbackCollectionRequest,
): Promise<CreateFeedbackCollectionResult> {
  const response = await createFeedbackCollectionApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to create feedback link (${response.status})`);
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to create feedback link");
  }

  return response.data;
}
